module.exports = __webpack_public_path__ + "static/media/pixcel.f091b550.png";